module.exports = __webpack_public_path__ + "static/ritual_duvel_glass.0857ae94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_stories/_ritual/ritual_duvel_glass.jpg
// module id = 915
// module chunks = 4869420489019